export default {
      id: "icon-link-usage",
      viewBox: "-2 -8 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-link",
      toString: function () {
        return this.url;
      }
    }